import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'

import Typography from '@material-ui/core/Typography'
import ProgressLoader from 'components/atoms/ProgressLoader'

const styles = theme => ({
  root: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    transition: 'all .3s ease',
    backgroundImage: `linear-gradient(to right, ${theme.palette.background.medium} 0%, white 50%, ${theme.palette.background.medium} 100%)`,
  },
  content: {
    textAlign: 'center',
    marginBottom: theme.spacing(6),
  },
  hidden: {
    opacity: 0,
    pointerEvents: 'none',
    transition: 'opacity .5s ease',
  },
  subtitle: {
    maxWidth: 540,
    margin: '0 auto',
    marginTop: theme.spacing(1),
  },
})

const MapPlaceholder = ({
  classes,
  className,
  isHidden,
  showEmptyState,
  emptyStateTitle,
  emptyStateDescription,
}) => (
  <div
    className={classNames(
      classes.root,
      className,
      isHidden && !showEmptyState && classes.hidden
    )}>
    <div className={classes.content}>
      {showEmptyState ? (
        <Fragment>
          <Typography variant="h1">{emptyStateTitle}</Typography>
          <Typography className={classes.subtitle}>
            {emptyStateDescription}
          </Typography>
        </Fragment>
      ) : (
        <Fragment>
          <ProgressLoader color="#bbb" />
          <Typography variant="h1">Locating your traps</Typography>
          <Typography className={classes.subtitle}>
                one moment please
          </Typography>
        </Fragment>
      )}
    </div>
  </div>
)

MapPlaceholder.defaultProps = {
  emptyStateTitle: 'Looks like there are no traps added yet',
  emptyStateDescription:
    'Get started by sharing an invite code with Goodnature Chirp App users so they can share traps with you',
}

MapPlaceholder.propTypes = {
  isHidden: PropTypes.bool,
  classes: PropTypes.object,
  className: PropTypes.string,
  showEmptyState: PropTypes.bool,
  emptyStateTitle: PropTypes.string,
  emptyStateDescription: PropTypes.string,
}

export default withStyles(styles)(MapPlaceholder)



// WEBPACK FOOTER //
// ./src/components/atoms/MapPlaceholder.js